import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import {  isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { Subject } from 'rxjs';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { WorkflowComponent } from '../../workflow.component';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
//import DateHelpers from '../../../_infrastructure/DateHelpers';

@Component({
    selector: 'effectivity-map',
    templateUrl: './effectivity-map.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class EffectivityMapComponent implements OnInit, OnDestroy, ICardComponent,DoCheck {
  public cardData: models.EffectivityMapVM = {} as models.EffectivityMapVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public disableTableRemoveIcons: boolean = false;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.subscriberSituations)
  public subscriberSituations: models.DimensionVM[];
  @CommonData(DomainCodes.scheduleTypes)
  public scheduleTypes: models.DimensionVM[];
  @CommonData(DomainCodes.remunerationTypes)
  public remunerationTypes: models.DimensionVM[];
  public professionalClass: string;

  listChangeSubject = new Subject<string>();

  public filterStartDate: Date;
  public filterEndDate: Date;

  public preFilledItem: models.EffectivityEntryVM = <models.EffectivityEntryVM>{};
  public parentWorkflow: WorkflowComponent;
  public workflowDropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{};

  public isExSubscritor: boolean;
  public dataCessacao: Date;

  constructor(private modalService: ModalService, private stepDetailsService: StepDetailsService) {
    this.stepDetailsService.workFlowCode
    .subscribe(workflowCode => {
      if (workflowCode !== null && workflowCode !== undefined) {
        this.isExSubscritor = (workflowCode.indexOf('PEDI008') == -1 && workflowCode.indexOf('PEDI005') == -1) ? false : true;
      }
    });
  }

  ngOnInit(): void {
    if (this.isVersion2())
      this.workflowDropdowns = this.parentWorkflow.workflowDropdowns;

    //TEMP to prevent undefined errors if no stepdata is found
    if (isNullOrUndefined(this.cardData.effectivityList))
      this.cardData.effectivityList = [];
    else {
      this.sortEffectivityList(this.cardData.effectivityList);
    }

    if (this.isVersion2()) {
      if (!this.checkSteps()) {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus'].professionalCategoryCode;
      } else {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
      }

    }
  }

  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
    if (isNullOrUndefined(this.cardData.effectivityList))
      this.cardData.effectivityList = [];
  }

  ngOnDestroy(): void {
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parentWorkflow.steps.length; i++) {
      if (this.parentWorkflow.steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  onEffectivityListChanged(newList: models.EffectivityEntryVM[]): void {
    this.sortEffectivityList(newList);
    this.cardData.effectivityList = newList ;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;
    this.listChangeSubject.next("EffectivityListChanged");
  }

  removeEffectivity(index: number, event: MouseEvent): void {
    if (this.expandedRowIndex == null || this.expandedRowIndex == index) {
      confirmRemoveFromList(this.cardData.effectivityList, index, this.modalService).subscribe(result => {
        this.expandedRowIndex = null;
        if (result) {
          this.listChangeSubject.next("EffectivityListChanged");
        }
      });
    }
    event.stopPropagation();
  }

  onTimeLineClicked(clickedPeriod: models.TimelinePeriodVM): void {
    if (clickedPeriod.hasEffectivity) {
      this.filterStartDate = this.filterStartDate == clickedPeriod.startDate ? null : clickedPeriod.startDate;
      this.filterEndDate = this.filterEndDate == clickedPeriod.endDate ? null : clickedPeriod.endDate;
      this.preFilledItem = <models.EffectivityEntryVM>{};
      this.expandNewEntry = false;
    }
    else {
      this.onExpandNewEntry({ ...<models.EffectivityEntryVM>{}})
      this.filterStartDate = null;
      this.filterEndDate = null;
    }
    
  }

  onExpandNewEntry(preFilledEntry: models.EffectivityEntryVM = null): void {
    this.preFilledItem = isNullOrUndefined(preFilledEntry) ? <models.EffectivityEntryVM>{} : { ...preFilledEntry };
    this.expandNewEntry = !this.expandNewEntry;
  }

  onCloseNewEntry() {
    this.preFilledItem = <models.EffectivityEntryVM>{};
    this.expandNewEntry = !this.expandNewEntry;
  }

  isDate (date: string) {
    return (new Date(date).toString() !== "Invalid Date") && !isNaN(new Date(date).getTime()) && this.isGoodDate(date);
  }

  private isGoodDate(dt) {
    var reGoodDate = /^[0-9]{4}[-](?:(1[0-2]|0[1-9])[-](3[01]|[12][0-9]|0[1-9]))$/
    return reGoodDate.test(dt);
}

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  sortEffectivityList(effectivityList : models.EffectivityEntryVM[]) {
    effectivityList.sort((first, second) => first.startDate?.getTime() - second.startDate?.getTime());
  }

  translateBoolean(value: string): string {
    let result: string;
    if (value === 'true') {
      result = 'Sim';
    } else if (value === 'false') {
      result = 'Não';
    } else {
      result = '';
    }

    return result;
  }
}
